module.exports = __webpack_public_path__ + "static/media/shadow.14dc9e39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shadow.svg
// module id = 616
// module chunks = 0